import React, { useRef, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { FiMoreHorizontal } from 'react-icons/fi';
import { useWebLocale } from '../../../../contexts/WebLocaleContext';

// Album actions own confirmation. Other review routes retain their existing menu.
export default function AlbumReviewMenu({ onEdit, onRequestDelete }) {
  const { locale } = useWebLocale();
  const en = locale === 'en';
  const [anchor, setAnchor] = useState(null);
  const pending = useRef(null);
  const choose = (action) => {
    pending.current = action;
    setAnchor(null);
  };
  return (
    <>
      <IconButton
        aria-label={en ? 'My review options' : '내 리뷰 메뉴'}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{ width: 44, height: 44, color: 'var(--pp-text-primary)' }}
      >
        <FiMoreHorizontal size={20} />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => {
          pending.current = null;
          setAnchor(null);
        }}
        PaperProps={{
          sx: {
            background: 'var(--pp-surface)',
            color: 'var(--pp-text-primary)',
            '& .MuiMenuItem-root': { minHeight: 44, font: '400 14px/21px Pretendard, sans-serif' },
          },
        }}
        TransitionProps={{
          onExited: () => {
            const action = pending.current;
            pending.current = null;
            action?.();
          },
        }}
      >
        <MenuItem onClick={() => choose(onEdit)}>{en ? 'Edit Review' : '리뷰 수정'}</MenuItem>
        <MenuItem onClick={() => choose(onRequestDelete)}>
          {en ? 'Delete Review' : '리뷰 삭제'}
        </MenuItem>
      </Menu>
    </>
  );
}
